import { FC } from "react";
import { EXTERNAL } from "../../paths";
import Icon from "../components/Icon";
import { FOOTER_LINKS, LEGISLATION, renderSidebarLink } from "../components/LinkSidebar";

const Footer: FC = () => (
  <footer className="it-footer">
    <div className="it-wrap it-fgrid">
      <div className="it-fbrand">
        <img src="/uploads/2017/12/footerlogo-sol.png" alt="Securitas İtfaiye" />
        <p>
          Securitas İtfaiye Hizmetleri A.Ş. 7/24 profesyonel yangın güvenliği
          ve acil müdahale hizmetleri.
        </p>
        <div className="it-social">
          <a
            href={EXTERNAL.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <Icon name="in" />
          </a>
          <a
            href={EXTERNAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <Icon name="ig" />
          </a>
          <a
            href={EXTERNAL.introVideo}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <Icon name="yt" />
          </a>
        </div>
      </div>

      <div>
        <h5>Yangın Mevzuatı</h5>
        <ul>{LEGISLATION.map(renderSidebarLink)}</ul>
      </div>

      <div>
        <h5>Broşürler ve Faydalı Linkler</h5>
        <ul>{FOOTER_LINKS.map(renderSidebarLink)}</ul>
      </div>

      <div>
        <h5>İletişim</h5>
        <ul className="it-fcontact">
          <li>
            <b>Adres</b>
            <a
              href="https://www.google.com/maps?q=Ceyhun+Atıf+Kansu+Caddesi+112/15,+Balgat/ANKARA"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ceyhun Atıf Kansu Caddesi 112/15, Balgat / Ankara
            </a>
          </li>
          <li>
            <b>Telefon</b>
            <a href="tel:03124735990">(0312) 473 5990</a> · Faks: (0312) 473 5996
          </li>
          <li>
            <b>E-posta</b>
            <a href="mailto:itfaiye@securitas.com.tr">itfaiye@securitas.com.tr</a>
          </li>
        </ul>
      </div>
    </div>
    <div className="it-wrap it-fbottom">
      <span>
        © {new Date().getFullYear()} Securitas İtfaiye Hizmetleri A.Ş. Tüm
        hakları saklıdır.
      </span>
      <span>Securitas Güvenlik Hizmetleri A.Ş. iştirakidir.</span>
    </div>
  </footer>
);

export default Footer;
